import * as tslib_1 from "tslib";
import { ShadingMethodBase } from "./ShadingMethodBase";
/**
 * EffectLightMapMethod provides a method that allows applying a light map texture to the calculated pixel colour.
 * It is different from DiffuseLightMapMethod in that the latter only modulates the diffuse shading value rather
 * than the whole pixel colour.
 */
var EffectLightMapMethod = (function (_super) {
    tslib_1.__extends(EffectLightMapMethod, _super);
    /**
     * Creates a new EffectLightMapMethod object.
     *
     * @param lightMap The texture containing the light map.
     * @param blendMode The blend mode with which the light map should be applied to the lighting result.
     * @param useSecondaryUV Indicates whether the secondary UV set should be used to map the light map.
     */
    function EffectLightMapMethod(lightMap, blendMode, useSecondaryUV) {
        if (blendMode === void 0) { blendMode = "multiply"; }
        if (useSecondaryUV === void 0) { useSecondaryUV = false; }
        var _this = _super.call(this) || this;
        if (blendMode != EffectLightMapMethod.ADD && blendMode != EffectLightMapMethod.MULTIPLY)
            throw new Error("Unknown blendmode!");
        _this._lightMap = lightMap;
        _this._blendMode = blendMode;
        _this._useSecondaryUV = useSecondaryUV;
        if (_this._lightMap)
            _this.iAddTexture(_this._lightMap);
        return _this;
    }
    Object.defineProperty(EffectLightMapMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectLightMapMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectLightMapMethod.prototype, "blendMode", {
        /**
         * The blend mode with which the light map should be applied to the lighting result.
         *
         * @see EffectLightMapMethod.ADD
         * @see EffectLightMapMethod.MULTIPLY
         */
        get: function () {
            return this._blendMode;
        },
        set: function (value) {
            if (this._blendMode == value)
                return;
            if (value != EffectLightMapMethod.ADD && value != EffectLightMapMethod.MULTIPLY)
                throw new Error("Unknown blendmode!");
            this._blendMode = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectLightMapMethod.prototype, "lightMap", {
        /**
         * The lightMap containing the light map.
         */
        get: function () {
            return this._lightMap;
        },
        set: function (value) {
            if (this._lightMap == value)
                return;
            if (this._lightMap)
                this.iRemoveTexture(this._lightMap);
            this._lightMap = value;
            if (this._lightMap)
                this.iAddTexture(this._lightMap);
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectLightMapMethod.prototype, "useSecondaryUV", {
        /**
         * Indicates whether the secondary UV set should be used to map the light map.
         */
        get: function () {
            return this._useSecondaryUV;
        },
        set: function (value) {
            if (this._useSecondaryUV == value)
                return;
            this._useSecondaryUV = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    return EffectLightMapMethod;
}(ShadingMethodBase));
export { EffectLightMapMethod };
/**
 * Indicates the light map should be multiplied with the calculated shading result.
 */
EffectLightMapMethod.MULTIPLY = "multiply";
/**
 * Indicates the light map should be added into the calculated shading result.
 */
EffectLightMapMethod.ADD = "add";
EffectLightMapMethod.assetType = "[asset EffectLightMapMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/EffectLightMapMethod.js